import React from "react"
import { Link } from "gatsby"

const RedSoda = ({ routeParams }) => (
  <div className="red-soda-container">
    <div className="title-header">
      <h3 className="font-syne font-bold">RED SODA</h3>
    </div>
    <ul className="font-montserrat-13">
      <li>
        <div className="link">
          <Link
            to={`/${routeParams?.location}/red-soda-wedding-band${
              routeParams?.location?.includes("boston")
                ? ""
                : "-" + routeParams?.location?.split("/")[1]
            }/`}
          >
            About Us
          </Link>
        </div>
      </li>
      <li>
        <div className="link">
          <Link to={`/${routeParams?.location}/faq/`}>FAQs</Link>
        </div>
      </li>
      <li>
        <div className="link">
          <Link to={`/${routeParams?.location}/blog/`}>Blog</Link>
        </div>
      </li>
      <li>
        <div className="link">
          <Link to={`/${routeParams?.location}/contact-red-soda/`}>
            Contact
          </Link>
        </div>
      </li>
      <li>
        <div className="link">
          <Link to={`/${routeParams?.location}/testimonials/`}>
            Testimonials
          </Link>
        </div>
      </li>
    </ul>
  </div>
)

export default RedSoda
